import { createSlice } from '@reduxjs/toolkit';

const compHistory = [
  {
    year: "2022",
    items: [
      "페데스탈 통신모듈 개발 완료",
      "선석 관리 시스템 개발 완료",
      "페데스탈 제어 시스템 개발 완료",
    ],
  },
  {
    year: "2023",
    items: [
      "국산 페데스탈 개발 완료(특허)",
      "Exclusive 통합 통신모듈 개발(API)",
      "캠핑장 페데스탈 개발",
    ],
  },
  {
    year: "2024",
    items: [
      "제조 공장 설립",
      "해외 통합 페데스탈 수출",
      "Metaverse UI",
    ],
  },
  {
    year: "2025",
    items: [
      "Marina Platform 완성(결재/요트매매/서비스시설)",
      "페데스탈 교체(금융리스)",
      "페데스탈 제어 시스템 개발 완료",
    ],
  },
];
 
const getCompHistory = createSlice({
  name:'compHistSlice',
  initialState: {value : compHistory},
  reducers:{
    
    }
});



export default getCompHistory;